function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

(function setupInputModality() {
  const NAV_KEYS = new Set([
    'Tab',
    'ArrowUp',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
    'Home',
    'End',
    'PageUp',
    'PageDown',
    ' ',
    'Enter',
  ]);
  document.addEventListener('keydown', (event) => {
    if (event.metaKey || event.ctrlKey || event.altKey) return;
    if (NAV_KEYS.has(event.key)) document.documentElement.classList.add('js-focus-keyboard');
  }, { passive: true });
  document.addEventListener('pointerdown', () => {
    document.documentElement.classList.remove('js-focus-keyboard');
  }, { passive: true });
})();

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  #bindController = null;

  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.#bindController?.abort();
    this.#bindController = new AbortController();
    const signal = this.#bindController.signal;

    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this), { signal })
    );
    this.querySelectorAll('button:not(.localization-selector, .ignore-drawer-close)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this), { signal })
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    if (event.target.closest('a[href]')) return;

    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const parentMenu = detailsElement.closest('.menu-drawer__menu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  
    // Функция для удаления всех классов и сброса состояния
    function resetMenuState(menuElement) {
      menuElement.querySelectorAll('details').forEach((elem) => {
        elem.classList.remove('menu-opening', 'submenu-open');
        elem.removeAttribute('open');
        const summary = elem.querySelector('summary');
        if (summary) {
          summary.setAttribute('aria-expanded', false);
        }
      });
    }
  
    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button') || summaryElement.nextElementSibling);
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }
  
    // Если это главный элемент меню (parent-menu)
    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) {
        event.preventDefault();
        // Закрываем все вложенные меню и сбрасываем их состояние
        resetMenuState(detailsElement);
        this.closeMenuDrawer(event, summaryElement);
      } else {
        if (this.classList.contains('mobile-facets__wrapper')) {
          event.preventDefault();
        }
        this.openMenuDrawer(summaryElement);

        if (window.matchMedia('(max-width: 990px)')) {
          document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
        }
      }
    } else {
      // Если вложенное меню уже открыто, закрываем его
      if (isOpen) {
        parentMenu.removeAttribute('open');
        parentMenu.classList.remove('menu-opening');
        summaryElement.setAttribute('aria-expanded', false);
        const parentMenuElement = detailsElement.closest('.submenu-open');
        parentMenuElement && parentMenuElement.classList.remove('submenu-open');
        return;
      }
  
      // Проверка вложенности и управление родителем
      if (parentMenu && parentMenu.hasAttribute('open')) {
        parentMenu.classList.add('menu-opening');
        parentMenu.setAttribute('open', '');
      } else {
        parentMenu.removeAttribute('open');
        parentMenu.classList.remove('menu-opening');
        parentMenu.querySelector('summary').setAttribute('aria-expanded', false);
      }
  
      // Закрываем другие вложенные меню
      const openSubmenus = parentMenu?.querySelectorAll('.menu-drawer__menu li > .menu-opening');
      if (openSubmenus) {
        openSubmenus.forEach((elem) => {
          if (elem !== detailsElement) {
            elem.removeAttribute('open');
            elem.classList.remove('menu-opening');
            elem.querySelector('summary').setAttribute('aria-expanded', false);
          }
        });
      }
  
      // Открываем текущее вложенное меню
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        detailsElement.setAttribute('open', '');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    summaryElement.setAttribute('aria-expanded', true);
    this.mainDetailsToggle.setAttribute('open', '');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');

      let elementToFocus = summaryElement;
      if (this.classList.contains('mobile-facets__wrapper')) {
        const root = this.mainDetailsToggle;
        const firstCheckbox = root.querySelector('.mobile-facets__checkbox:not(:disabled)');
        const closeControl = root.querySelector('.facets_close_btn');
        elementToFocus = firstCheckbox || closeControl || summaryElement;
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          trapFocus(this.mainDetailsToggle, elementToFocus);
        });
      });
    }, 0);

    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    if (detailsElement === this.mainDetailsToggle) {
      this.mainDetailsToggle.querySelector('summary').click();
    } else {
      this.closeSubmenu(detailsElement);
    }
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');


    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  #productDotClicksBound = false;

  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage;

    const dotBlock = this.querySelector('.product-slider-buttons');
    if (dotBlock && !this._productDotClicksBound) {
      this._productDotClicksBound = true;
      dotBlock.addEventListener('click', this.onDotClick.bind(this));
    }

    this.update();
  }

  onDotClick(event) {
    const dot = event.target.closest('.dot');
    if (!dot || !this.slider || this.sliderItemOffset == null) return;
    event.preventDefault();
    const idx = parseInt(dot.getAttribute('data-index'), 10);
    if (Number.isNaN(idx) || idx < 0) return;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.slider.scrollTo({
      left: idx * this.sliderItemOffset,
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
    });
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    this.sliderControlButtons = this.querySelectorAll('.product-slider-buttons .dot');

    if (!this.sliderControlButtons.length) return;

    const activeIdx = Math.min(Math.max(this.currentPage, 1), this.sliderControlButtons.length) - 1;
    const activeBtn = this.sliderControlButtons[activeIdx];
    if (!activeBtn) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('dot--active');
      link.removeAttribute('aria-current');
    });
    activeBtn.classList.add('dot--active');
    activeBtn.setAttribute('aria-current', true);


    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.slider.addEventListener('scroll', this.update.bind(this));

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector('.announcement-bar-slider')) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia('(min-width: 750px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      [this.reducedMotion, this.desktopLayout].forEach((mediaQuery) => {
        mediaQuery.addEventListener('change', () => {
          if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener('click', () => {
          this.announcementBarArrowButtonWasClicked = true;
        }, {once: true});
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked || !this.desktopLayout.matches ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked && this.desktopLayout.matches) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.querySelector('.announcement-bar-slider').contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class HomepageSlideshowComponent extends HTMLElement {
  constructor() {
    super();
    this.footer = null;
    this.intersectionObserver = null;
  }
  
  connectedCallback() {
    this.footer = document.querySelector('footer');
    
    if (this.footer) {
      this.initIntersectionObserver();
    }
  }
  
  disconnectedCallback() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
  }
  
  initIntersectionObserver() {
    if (!('IntersectionObserver' in window)) {
      return;
    }
    
    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.classList.add('navigation-hidden');
          } else {
            this.classList.remove('navigation-hidden');
          }
        });
      }
    );
    
    this.intersectionObserver.observe(this.footer);
  }
}

customElements.define('homepage-slideshow', HomepageSlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.filterImgVariant();
    this.updateLegend();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }
  
  updateLegend(variant) {
    let legendVariant = document.querySelector('.id-legend-color')
    let parse = {...variant};
    let variantName = parse.option1;
    if (variantName) {
      legendVariant.innerText = 'Color: ' + variantName.toLowerCase();
    }
  }

  filterImgVariant() {
    if(this.currentVariant.featured_image && this.currentVariant.featured_image.alt ) {
      document.querySelectorAll('[thumbnail-alt]').forEach(img => {img.style.display = 'none';img.setAttribute('current-items', false)});
      const currentImgAlt = this.currentVariant.featured_image.alt;
      const thumbnailSelector = `[thumbnail-alt = '${currentImgAlt}']`;
      document.querySelectorAll(thumbnailSelector).forEach(img => {img.style.display = 'block';img.setAttribute('current-items', true)});
      setupSlider();
    } else {
      document.querySelectorAll('[thumbnail-alt]').forEach(img => {img.style.display = 'block';img.setAttribute('current-items', true)});
      setupSlider();
    }
  } 

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
    this.updateLegend(this.currentVariant);
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class ChatButton extends HTMLElement {
  static #isOpen = false;
  static #listenersRegistered = false;
  #button = null;

  connectedCallback() {
    this.#button = this.querySelector('.chat-button');
    if (!this.#button) return;

    this.#button.addEventListener('click', this.#handleActivate);
    this.#setupZendeskListeners();
  }

  #setupZendeskListeners() {
    if (ChatButton.#listenersRegistered) return;

    const register = () => {
      if (typeof zE === 'undefined') return;
      ChatButton.#listenersRegistered = true;
      zE('messenger:on', 'open', () => { ChatButton.#isOpen = true; });
      zE('messenger:on', 'close', () => { ChatButton.#isOpen = false; });
    };

    if (typeof zE !== 'undefined') {
      register();
    } else {
      window.addEventListener('load', register, { once: true });
    }
  }

  #handleActivate = () => {
    if (typeof zE === 'undefined') return;
    ChatButton.#isOpen = sessionStorage.getItem('ZD-widgetOpen') === 'true';
    zE('messenger', ChatButton.#isOpen ? 'close' : 'open');
  };
}

if (!customElements.get('chat-button')) {
  customElements.define('chat-button', ChatButton);
}


//Custom slider PDP
let _pdpScrollHandler = null;
let _pdpThumbHandlers = [];

function setupSlider() {
  // Clean up listeners from previous call (variant change)
  if (_pdpScrollHandler) {
    window.removeEventListener('scroll', _pdpScrollHandler);
    _pdpScrollHandler = null;
  }
  _pdpThumbHandlers.forEach(({ el, fn }) => el.removeEventListener('click', fn));
  _pdpThumbHandlers = [];

  let thumb = document.querySelectorAll('.small-hide .thumbnail-list__item[current-items="true"]'),
      btn = document.querySelectorAll('.small-hide .thumbnail-list__item[current-items="true"] .thumbnail'),
      slides = document.querySelectorAll('.product__media-list .product__media-item[current-items="true"]');

  if (!slides.length) return;

  let is_scroll = true;

  if (thumb.length > 0) {
    thumb.forEach((element, index) => {
      const fn = function(e) {
        e.preventDefault();
        is_scroll = false;
        let block = slides[index];
        if (block) {
          block.scrollIntoView({ behavior: 'smooth', block: 'start' });
          btn.forEach((b, i) => {
            if (i === index) b.setAttribute('aria-current', true);
            else b.removeAttribute('aria-current');
          });
        }
        setTimeout(function() { is_scroll = true; }, 600);
      };
      element.addEventListener('click', fn);
      _pdpThumbHandlers.push({ el: element, fn });
    });
  }

  _pdpScrollHandler = function() {
    if (!is_scroll) return;
    let activeIndex = findVisibleSlideIndex(slides);
    btn.forEach((element, index) => {
      if (index === activeIndex) element.setAttribute('aria-current', true);
      else element.removeAttribute('aria-current');
    });
  };
  window.addEventListener('scroll', _pdpScrollHandler, { passive: true });

  if (btn.length > 0) {
    btn[0].setAttribute('aria-current', true);
  }
}

function findVisibleSlideIndex(slides) {
  const threshold = 0.4;
  for (let i = 0; i < slides.length; i++) {
    const rect = slides[i].getBoundingClientRect();
    const visibleTop = Math.max(rect.top, 0);
    const visibleBottom = Math.min(rect.bottom, window.innerHeight);
    if (visibleBottom > visibleTop) {
      const visiblePercentage = (visibleBottom - visibleTop) / rect.height;
      if (visiblePercentage >= threshold) return i;
    }
  }
  return 0;
}

document.addEventListener("DOMContentLoaded", () => {
  setupSlider();

  // Custom slider Homepage Banner Slideshow and Menu Navigation
  const navEl = document.querySelector('.swiper-nav');
  const menuEl = document.querySelector('.swiper-menu');

  let swiper_nav;
  let swiper_menu;

  if (navEl && menuEl) {
    const menuSlides = menuEl.querySelectorAll('.swiper-slide');
    const navSlides = navEl.querySelectorAll('.swiper-slide');

    if (menuSlides.length) {
      swiper_nav = new Swiper(navEl, {
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
        focusableElements: 'input, select, option, textarea, button:not(.menu-drawer__tabs-link), video, label',
        on: {
          afterInit: function() {
            this.slides.forEach((slide) => {
              slide.removeAttribute('role');
            });
          }
        }
      });

      const initialSlideIndexAttr = menuEl.getAttribute('data-menu-active-index');
      const initialSlideIndex = Number.parseInt(initialSlideIndexAttr ?? '0', 10);

      swiper_menu = new Swiper(menuEl, {
        loop: menuSlides.length > 1,
        slidesPerView: 1,
        autoHeight: true,
        initialSlide: Number.isFinite(initialSlideIndex) ? initialSlideIndex : 0,
        a11y: { scrollOnFocus: false },
        thumbs: navSlides.length ? { swiper: swiper_nav } : undefined,
      });

      function updateMenuTabindex() {
        menuEl.querySelectorAll('.menu-drawer__tab').forEach((slide, i) => {
          const isActive = swiper_menu.realIndex === i;
          slide.querySelectorAll('a, button, summary').forEach((el) => {
            if (isActive) el.removeAttribute('tabindex');
            else el.setAttribute('tabindex', '-1');
          });
        });
      }

      const menuDrawerNavEl = menuEl.closest('.menu-drawer__navigation');

      swiper_menu.on('slideChange', updateMenuTabindex);
      updateMenuTabindex();

      menuEl.querySelectorAll('details').forEach((details) => {
        details.addEventListener('toggle', () => swiper_menu.updateAutoHeight(300));
      });

      document.querySelectorAll('.menu-drawer__tabs-link').forEach((tab, index) => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          if (menuDrawerNavEl) menuDrawerNavEl.scrollTop = 0;
          swiper_menu.slideToLoop(index);
        });

        tab.addEventListener('keydown', (e) => {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          if (menuDrawerNavEl) menuDrawerNavEl.scrollTop = 0;
          swiper_menu.slideToLoop(index);
          menuEl.querySelectorAll('.menu-drawer__tab')[index]?.querySelector('a')?.focus({ preventScroll: true });
        });
      });
    }
  }

  const bannersNavEl = document.querySelector('.swiper-banners-nav');
  const bannersEl = document.querySelector('.swiper-banners');

  if (bannersNavEl && bannersEl) {
    const bannerSlides = bannersEl.querySelectorAll('.swiper-slide');
    const bannerNavSlides = bannersNavEl.querySelectorAll('.swiper-slide');

    const swiper_banners_nav = new Swiper(bannersNavEl, {
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
    });

    const swiper_banners = new Swiper(bannersEl, {
      lazy: true,
      autoHeight: true,
      loop: bannerSlides.length > 1,
      slidesPerView: 1,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: bannerNavSlides.length ? { swiper: swiper_banners_nav } : undefined,
    });

    let isSyncing = false;

    swiper_banners.on('realIndexChange', function() {
      if (isSyncing || !swiper_menu || !swiper_menu.slides.length) return;
      isSyncing = true;
      if (swiper_banners.realIndex < swiper_menu.slides.length) {
        swiper_menu.slideToLoop(swiper_banners.realIndex);
      }
      setTimeout(() => isSyncing = false, 100);
    });

    swiper_menu?.on('realIndexChange', function() {
      if (isSyncing || !swiper_banners || !swiper_banners.slides.length) return;
      isSyncing = true;
      if (swiper_menu.realIndex < swiper_banners.slides.length) {
        swiper_banners.slideToLoop(swiper_menu.realIndex);
      }
      setTimeout(() => isSyncing = false, 100);
    });

  }
});

function parseCartAddErrorMessage(data) {
  if (!data || typeof data !== 'object') return '';
  if (typeof data.description === 'string' && data.description.trim()) {
    return data.description.trim();
  }
  if (typeof data.message === 'string' && data.message.trim()) {
    return data.message.trim();
  }
  const err = data.errors;
  if (err && typeof err === 'object' && !Array.isArray(err)) {
    const msgs = [];
    for (const key of Object.keys(err)) {
      const val = err[key];
      if (Array.isArray(val)) {
        val.forEach((item) => {
          if (typeof item === 'string' && item.trim()) msgs.push(item.trim());
        });
      } else if (typeof val === 'string' && val.trim()) {
        msgs.push(val.trim());
      }
    }
    const joined = msgs.join(' ');
    if (joined) return joined;
  }
  return '';
}

function setQuickAddErrorPrimaryText(root, apiMessage) {
  if (!root) return;
  const primary = root.querySelector('.js-quick-add-error-primary');
  if (!primary) return;
  const defaultText = primary.getAttribute('data-error-default') || '';
  const trimmed = typeof apiMessage === 'string' ? apiMessage.trim() : '';
  primary.textContent = trimmed || defaultText;
}

function removeQuickAddNotifications(container) {
  if (!container) return;
  container.querySelectorAll('[data-quick-add-notification]').forEach((el) => el.remove());
}

function mountQuickAddNotification(host, status, errorMessage = '') {
  const tplName = status === 'success' ? 'success' : 'error';
  const outletSelector =
    host.tagName === 'CARD-QUICK-ADD' ? '.card-quick-add__notifications' : '.quick-add__notifications';
  const tpl = host.querySelector(`template[data-quick-add-template="${tplName}"]`);
  const outlet = host.querySelector(outletSelector);
  if (!tpl || !outlet) return null;
  const node = tpl.content.firstElementChild?.cloneNode(true);
  if (!node) return null;
  node.setAttribute('data-quick-add-notification', '');
  if (status === 'error') {
    setQuickAddErrorPrimaryText(node, errorMessage);
  }
  outlet.appendChild(node);
  requestAnimationFrame(() => {
    node.classList.add('is-visible');
  });
  return node;
}

function focusQuickAddSuccessLink(notificationRoot) {
  if (!notificationRoot) return;
  if (window.matchMedia('(hover: none)').matches) return;
  const link =
    notificationRoot.querySelector('.card-quick-add__confirmation-link') ||
    notificationRoot.querySelector('.quick-add__confirmation-link');
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      link?.focus({ preventScroll: true });
    });
  });
}

// Card quick-add: button toggles <dialog> on desktop; mobile uses quick-add:open-options → toast.
class CardQuickAdd extends HTMLElement {
  #notificationDismissTimeout = null;

  connectedCallback() {
    this.trigger = this.querySelector('[data-card-quick-add-trigger]');
    this.variantDialog = this.querySelector('.card-quick-add__add-to-cart-dropdown');

    this.onClick = this.handleClick.bind(this);
    this.onKeyUp = this.handleKeyUp.bind(this);
    this.onKeyDown = this.handleKeyDown.bind(this);
    this.onDocumentClick = this.handleDocumentClick.bind(this);
    this.addEventListener('click', this.onClick);
    this.addEventListener('keyup', this.onKeyUp);
    this.addEventListener('keydown', this.onKeyDown);
  }

  disconnectedCallback() {
    this.clearQuickAddLiveState();
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('keyup', this.onKeyUp);
    this.removeEventListener('keydown', this.onKeyDown);
    document.removeEventListener('click', this.onDocumentClick, true);
  }

  clearQuickAddLiveState() {
    if (this.#notificationDismissTimeout) {
      clearTimeout(this.#notificationDismissTimeout);
      this.#notificationDismissTimeout = null;
    }
    removeQuickAddNotifications(this);
  }

  openDesktopPanel() {
    if (this.variantDialog && !this.variantDialog.open) {
      this.variantDialog.removeAttribute('inert');
      this.variantDialog.show();
    }
    this.setAttribute('open', '');
    document.addEventListener('click', this.onDocumentClick, true);
    const firstOption = this.querySelector('button.card-quick-add__variant-option:not([disabled])');
    if (firstOption) firstOption.focus({ preventScroll: true });
  }

  closeDesktopPanel(options = {}) {
    const { focusTrigger = true } = options;
    if (!this.hasAttribute('open')) return;
    document.removeEventListener('click', this.onDocumentClick, true);
    this.removeAttribute('open');
    if (this.variantDialog?.open) this.variantDialog.close();
    if (this.variantDialog) this.variantDialog.setAttribute('inert', '');
    if (focusTrigger && this.trigger) this.trigger.focus({ preventScroll: true });
  }

  handleClick(event) {
    const trigger = event.target.closest('[data-card-quick-add-trigger]');
    if (trigger && this.contains(trigger)) {
      if (window.matchMedia('(min-width: 990px)').matches) {
        if (this.hasAttribute('open')) {
          this.closeDesktopPanel();
        } else {
          this.openDesktopPanel();
        }
      } else {
        // Ensure we have a reliable focus return target for the mobile panel/toast flow.
        trigger.focus({ preventScroll: true });
        document.dispatchEvent(new CustomEvent('quick-add:open-options', { detail: { source: this } }));
      }
      return;
    }

    const variantBtn = event.target.closest('.card-quick-add__variant-option[data-variant-id]');
    if (!variantBtn || variantBtn.disabled || !this.contains(variantBtn)) return;

    event.preventDefault();
    event.stopPropagation();

    // Keep focus stable for keyboard + a11y: prevent it from falling back to <body>
    // when click handlers stop propagation/default.
    if (document.activeElement !== variantBtn) {
      variantBtn.focus({ preventScroll: true });
    }

    this.clearQuickAddLiveState();
    document.querySelector('add-to-cart-form.quick-add--toast')?.clearQuickAddLiveState?.();

    const variantId = variantBtn.getAttribute('data-variant-id');

    this.querySelectorAll('.card-quick-add__variant-option').forEach((btn) => {
      btn.classList.toggle('is-selected', btn.getAttribute('data-variant-id') === variantId);
    });

    this.addToCart(variantId);
  }

  showConfirmation(status, errorMessage = '') {
    if (!status) return;

    const shouldUseGlobalToast = window.matchMedia('(max-width: 989px)').matches;
    const globalToast = document.querySelector('add-to-cart-form.quick-add--toast');
    if (shouldUseGlobalToast && globalToast?.showStatus) {
      globalToast.closeOptions();
      globalToast.showStatus(status, errorMessage);
      return;
    }

    if (this.#notificationDismissTimeout) {
      clearTimeout(this.#notificationDismissTimeout);
      this.#notificationDismissTimeout = null;
    }
    removeQuickAddNotifications(this);

    const node = mountQuickAddNotification(this, status, errorMessage);
    
    if (!node) return;
    
    if (status === 'success') {
      focusQuickAddSuccessLink(node);

      const focusFallback = () => {
        if (window.matchMedia('(hover: none)').matches) return false;
        const trigger =
          (this.trigger?.isConnected && this.trigger) ||
          this.querySelector?.('[data-card-quick-add-trigger]');
        if (trigger?.isConnected && trigger.focus) {
          trigger.focus({ preventScroll: true });
          return document.activeElement === trigger;
        }
        return false;
      };

      // Auto-dismiss regardless of focus state (otherwise it can hang if focus stays on the link).
      this.#notificationDismissTimeout = setTimeout(() => {
        const activeBeforeRemove = document.activeElement;
        if (node.isConnected) node.remove();
        this.#notificationDismissTimeout = null;
        const didFocus = focusFallback();
        if (!didFocus) {
          // If the active element was removed together with the notification, blur it.
          if (activeBeforeRemove && !document.contains(activeBeforeRemove)) activeBeforeRemove.blur?.();
        }
      }, 5000);

      // If user interacted with the notification, let it stay until they leave it,
      // but still keep an upper bound (restart the timer).
      node.addEventListener(
        'focusin',
        () => {
          if (this.#notificationDismissTimeout) clearTimeout(this.#notificationDismissTimeout);
          this.#notificationDismissTimeout = setTimeout(() => {
            const activeBeforeRemove = document.activeElement;
            if (node.isConnected) node.remove();
            this.#notificationDismissTimeout = null;
            const didFocus = focusFallback();
            if (!didFocus) {
              if (activeBeforeRemove && !document.contains(activeBeforeRemove)) activeBeforeRemove.blur?.();
            }
          }, 5000);
        },
        { once: true }
      );
    } else {
      this.#notificationDismissTimeout = setTimeout(() => {
        if (node.isConnected) node.remove();
        this.#notificationDismissTimeout = null;
      }, 5000);
    }
  }

  handleDocumentClick(event) {
    if (this.contains(event.target)) return;
    this.closeDesktopPanel({ focusTrigger: false });
  }

  handleKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    if (!this.hasAttribute('open')) return;
    this.closeDesktopPanel();
  }

  handleKeyDown(event) {
    if (event.code.toUpperCase() !== 'TAB') return;
    if (!this.hasAttribute('open')) return;

    const dropdown = this.variantDialog;
    if (!dropdown) return;

    const focusable = Array.from(
      dropdown.querySelectorAll('button:not([disabled]), a[href]')
    );
    if (focusable.length === 0) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const sectionEl = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return sectionEl ? sectionEl.innerHTML : '';
  }

  addToCart(variantId) {
    const activeOption = this.querySelector(`.card-quick-add__variant-option[data-variant-id="${variantId}"]`);
    if (activeOption) activeOption.setAttribute('aria-busy', 'true');

    const cartDrawer = document.querySelector('cart-drawer');
    const cartNotification = document.querySelector('cart-notification');
    const cart = cartDrawer || cartNotification;
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.set('id', variantId);

    const hasGetSectionsToRender = cart && typeof cart.getSectionsToRender === 'function';
    const hasRenderContents = cart && typeof cart.renderContents === 'function';
    const sectionsToRender = hasGetSectionsToRender
      ? cart.getSectionsToRender().map((section) => section.id)
      : ['cart-icon-bubble'];
    formData.append('sections', sectionsToRender);
    formData.append('sections_url', window.location.pathname);
    if (cart?.setActiveElement) cart.setActiveElement(document.activeElement);

    config.body = formData;

    let addStatus = null;
    let addErrorMessage = '';
    return fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response?.status) {
          addStatus = 'error';
          addErrorMessage = parseCartAddErrorMessage(response);
          return;
        }

        const cartIconEl = document.getElementById('cart-icon-bubble');
        if (hasRenderContents) {
          cart.renderContents(response);
        } else if (cartIconEl && response?.sections?.['cart-icon-bubble']) {
          cartIconEl.innerHTML = this.getSectionInnerHTML(response.sections['cart-icon-bubble']);
        }
        addStatus = 'success';
      })
      .catch((e) => {
        console.error(e);
        addStatus = 'error';
        addErrorMessage = '';
      })
      .finally(() => {
        if (activeOption) activeOption.removeAttribute('aria-busy');
        this.closeDesktopPanel({ focusTrigger: false });
        this.showConfirmation(addStatus, addErrorMessage);
      });
  }
}

if (!customElements.get('card-quick-add')) {
  customElements.define('card-quick-add', CardQuickAdd);
}

// PDP custom quick-add drawer
class ProductCustomQuickAdd extends HTMLElement {
  #tabTrapAttached = false;

  constructor() {
    super();

    this.onViewCartTimeout = null;
    this.lastFocusedElement = null;
    this.justOpened = false;
    this.drawer = null;
    this.trigger = null;
    this.viewCart = null;

    this.onClick = this.#handleClick.bind(this);
    this.onOutsidePointerDown = this.#handleOutsidePointerDown.bind(this);
    this.onKeyDown = this.#handleKeyDown.bind(this);
    this.onDialogClose = this.#handleDialogClose.bind(this);
  }

  connectedCallback() {
    this.drawer = this.querySelector('.product-custom-quick-add__drawer');
    this.trigger = this.querySelector('.product-custom-quick-add__trigger');
    this.viewCart = this.querySelector('.product-custom-quick-add__view-cart');
    if (!this.drawer || !this.trigger || !this.viewCart) return;

    this.drawer.addEventListener('close', this.onDialogClose);
    this.drawer.addEventListener('click', (e) => { if (e.target === this.drawer) this.close(); });
    this.addEventListener('click', this.onClick);

    const footer = document.querySelector('footer');
    if (footer) {
      this.galleryObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.trigger.classList.toggle('product__info-mobile-sticky-button--hidden', entry.isIntersecting);
        });
      });
      this.galleryObserver.observe(footer);
    }
  }

  disconnectedCallback() {
    if (this.onClick) this.removeEventListener('click', this.onClick);
    if (this.drawer) this.drawer.removeEventListener('close', this.onDialogClose);
    this.#removeOpenStateListeners();
    if (this.onViewCartTimeout) {
      clearTimeout(this.onViewCartTimeout);
      this.onViewCartTimeout = null;
    }
    document.body.classList.remove('overflow-hidden-mobile');
    if (this.galleryObserver) {
      this.galleryObserver.disconnect();
      this.galleryObserver = null;
    }
  }

  #handleClick(event) {
    const closeTrigger = event.target.closest('[data-product-custom-quick-add-close]');
    if (closeTrigger) {
      event.preventDefault();
      event.stopPropagation();
      this.lastFocusedElement = null;
      this.close();
      return;
    }

    const openTrigger = event.target.closest('.product-custom-quick-add__trigger');
    if (openTrigger) {
      event.preventDefault();
      this.open();
      return;
    }

    const modalOpener = event.target.closest('modal-opener');
    if (modalOpener) {
      this.close();
      return;
    }

    const optionButton = event.target.closest('.card-quick-add__variant-option');
    if (!optionButton || optionButton.disabled) return;

    const variantId = optionButton.getAttribute('data-variant-id');
    if (!variantId) return;

    event.preventDefault();

    optionButton.setAttribute('aria-busy', 'true');
    this.addToCart(variantId)
      .then(() => this.close())
      .finally(() => optionButton.removeAttribute('aria-busy'));
  }

  #handleOutsidePointerDown(event) {
    if (!this.drawer?.open) return;
    if (this.justOpened) return;
    const inside = this.drawer.contains(event.target);
    if (inside) return;
    if (event.target.closest('[data-product-custom-quick-add-close]')) return;

    event.stopPropagation();
    this.close();
  }

  #handleKeyDown(event) {
    if (event.key !== 'Escape') return;
    if (!this.drawer?.open) return;
    event.preventDefault();
    this.close();
  }

  #handleDialogClose() {
    this.removeAttribute('data-open');
    document.body.classList.remove('overflow-hidden-mobile');
    this.#removeOpenStateListeners();
    if (this.lastFocusedElement?.focus) this.lastFocusedElement.focus();
    this.lastFocusedElement = null;
  }

#addOpenStateListeners() {
    document.addEventListener('pointerdown', this.onOutsidePointerDown, { capture: true });
    document.addEventListener('keydown', this.onKeyDown);
  }

  #removeOpenStateListeners() {
    document.removeEventListener('pointerdown', this.onOutsidePointerDown, { capture: true });
    document.removeEventListener('keydown', this.onKeyDown);
  }

  open() {
    if (!this.drawer) return;
    this.lastFocusedElement = document.activeElement;
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (isMobile) {
      this.drawer.showModal();
    } else {
      this.drawer.show();
    }

    // Usizy script scans `.usizy-external` on DOMContentLoaded; inside <dialog> it may need a rescan
    // once the dialog becomes visible. Trigger init only if the placeholder exists and adviser isn't injected yet.
    const usizyExternal = this.drawer.querySelector('.card-quick-add__variant-option--usizy .usizy-external');
    if (usizyExternal && window.uSizy && typeof window.uSizy.init === 'function') {
      const hasAdviser = !!usizyExternal.dataset?.btid && !!document.getElementById(usizyExternal.dataset.btid);
      if (!hasAdviser) {
        try { window.uSizy.init(); } catch (e) { /* noop */ }
      }
    }

    this.setAttribute('data-open', 'true');
    document.body.classList.add('overflow-hidden-mobile');

    this.justOpened = true;
    this.#addOpenStateListeners();
    requestAnimationFrame(() => {
      this.justOpened = false;
    });

    requestAnimationFrame(() => {
      const firstOption = this.drawer.querySelector('.card-quick-add__variant-option:not([disabled]):not(.card-quick-add__variant-option--label)');
      if (firstOption) firstOption.focus({ preventScroll: true });
    });
  }

  close() {
    if (!this.drawer?.open) return;
    this.drawer.close();
    // Остальное обрабатывает #handleDialogClose через событие 'close'
  }

  #showViewCartTemporarily() {
    if (!this.trigger || !this.viewCart) return;

    if (this.onViewCartTimeout) {
      clearTimeout(this.onViewCartTimeout);
      this.onViewCartTimeout = null;
    }

    this.trigger.hidden = true;
    this.viewCart.hidden = false;
    this.viewCart.focus({ preventScroll: true });

    this.onViewCartTimeout = setTimeout(() => {
      this.viewCart.hidden = true;
      this.trigger.hidden = false;
      this.trigger.focus({ preventScroll: true });
      this.onViewCartTimeout = null;
    }, 5000);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const sectionEl = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return sectionEl ? sectionEl.innerHTML : '';
  }

  showConfirmation(status, errorMessage = '') {
    removeQuickAddNotifications(this);
    const node = mountQuickAddNotification(this, status, errorMessage);
    if (node && status === 'success') {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      if (isMobile) {
        focusQuickAddSuccessLink(node);
        setTimeout(() => {
          if (node.isConnected) node.remove();
        }, 5000);
      } else {
        setTimeout(() => { if (node.isConnected) node.remove(); }, 5000);
        this.lastFocusedElement = null;
        this.#showViewCartTemporarily();
      }
    } else if (node) {
      setTimeout(() => { if (node.isConnected) node.remove(); }, 5000);
    }
  }

  addToCart(variantId) {
    const cartDrawer = document.querySelector('cart-drawer');
    const cartNotification = document.querySelector('cart-notification');
    const cart = cartDrawer || cartNotification;

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.set('id', variantId);

    const hasGetSectionsToRender = cart && typeof cart.getSectionsToRender === 'function';
    const hasRenderContents = cart && typeof cart.renderContents === 'function';
    const sectionsToRender = hasGetSectionsToRender
      ? cart.getSectionsToRender().map((section) => section.id)
      : ['cart-icon-bubble'];
    formData.append('sections', sectionsToRender);
    formData.append('sections_url', window.location.pathname);
    if (cart?.setActiveElement) cart.setActiveElement(document.activeElement);

    config.body = formData;

    return fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response?.status) {
          this.showConfirmation('error', parseCartAddErrorMessage(response));
          return 'error';
        }

        const cartIconEl = document.getElementById('cart-icon-bubble');
        if (hasRenderContents) {
          cart.renderContents(response);
        } else if (cartIconEl && response?.sections?.['cart-icon-bubble']) {
          cartIconEl.innerHTML = this.getSectionInnerHTML(response.sections['cart-icon-bubble']);
        }
        this.showConfirmation('success');
        return 'success';
      })
      .catch((e) => {
        console.error(e);
        this.showConfirmation('error');
        return 'error';
      });
  }
}

if (!customElements.get('product-custom-quick-add')) {
  customElements.define('product-custom-quick-add', ProductCustomQuickAdd);
}

class AddToCartFormToast extends HTMLElement {
  #notificationDismissTimeout = null;
  #modalTabTrapAttached = false;

  connectedCallback() {
    this.activeCardQuickAdd = null;
    this.lastFocusedElement = null;
    this.focusReturnElement = null;
    this.mobilePanel = this.querySelector('.quick-add-mobile-panel');
    this.mobilePanelOptions = this.querySelector('.quick-add-mobile-panel .quick-add__dropdown');

    this.onClick = this.handleClick.bind(this);
    this.onOpenOptionsRequest = this.handleOpenOptionsRequest.bind(this);
    this.onDialogClose = this.handleDialogClose.bind(this);
    this.onDocumentTabTrap = this.handleDocumentTabTrap.bind(this);
    this.onDialogClick = this.handleDialogClick.bind(this);
    this.addEventListener('click', this.onClick);
    document.addEventListener('quick-add:open-options', this.onOpenOptionsRequest);
    if (this.mobilePanel) {
      this.mobilePanel.addEventListener('close', this.onDialogClose);
      this.mobilePanel.addEventListener('click', this.onDialogClick);
    }
  }

  disconnectedCallback() {
    this.teardownModalTabTrap();
    if (this.mobilePanel) {
      this.mobilePanel.removeEventListener('click', this.onDialogClick);
      this.mobilePanel.removeEventListener('close', this.onDialogClose);
      if (this.mobilePanel.open) {
        this.finalizePanelClose();
        this.mobilePanel.close();
      }
    }
    if (this.onClick) this.removeEventListener('click', this.onClick);
    if (this.onOpenOptionsRequest) {
      document.removeEventListener('quick-add:open-options', this.onOpenOptionsRequest);
    }
    this.clearQuickAddLiveState();
    document.body.classList.remove('overflow-hidden-mobile');
  }

  clearQuickAddLiveState() {
    if (this.#notificationDismissTimeout) {
      clearTimeout(this.#notificationDismissTimeout);
      this.#notificationDismissTimeout = null;
    }
    removeQuickAddNotifications(this);
  }

  setModalIsolation(active) {
    if (!this.mobilePanel) return;
    Array.from(this.children).forEach((child) => {
      if (child === this.mobilePanel) return;
      if (active) {
        child.setAttribute('inert', '');
      } else {
        child.removeAttribute('inert');
      }
    });
  }

  teardownModalTabTrap() {
    if (this.#modalTabTrapAttached) {
      document.removeEventListener('keydown', this.onDocumentTabTrap, true);
      this.#modalTabTrapAttached = false;
    }
  }

  getModalVariantFocusables() {
    if (!this.mobilePanel?.open || !this.mobilePanelOptions) return [];
    return Array.from(
      this.mobilePanelOptions.querySelectorAll('button.card-quick-add__variant-option:not([disabled])')
    );
  }

  handleDocumentTabTrap(event) {
    if (!this.mobilePanel?.open || event.key !== 'Tab') return;

    const focusables = this.getModalVariantFocusables();
    if (focusables.length === 0) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    const active = document.activeElement;

    const activeInList = focusables.includes(active);

    if (!activeInList) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus({ preventScroll: true });
      return;
    }

    if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus({ preventScroll: true });
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus({ preventScroll: true });
    }
  }

  finalizePanelClose() {
    this.teardownModalTabTrap();
    this.setModalIsolation(false);
    document.body.classList.remove('overflow-hidden-mobile');
    const cardQuickAdd = this.activeCardQuickAdd;
    this.activeCardQuickAdd = null;
    cardQuickAdd?.removeAttribute('open');
    const cardDialog = cardQuickAdd?.querySelector('.card-quick-add__add-to-cart-dropdown');
    if (cardDialog?.open && typeof cardDialog.close === 'function') cardDialog.close();
    cardQuickAdd?.querySelector('[data-card-quick-add-trigger]')?.setAttribute('aria-expanded', 'false');
    const elToFocus = this.focusReturnElement || this.lastFocusedElement;
    if (elToFocus?.isConnected && elToFocus.focus) elToFocus.focus({ preventScroll: true });
    this.lastFocusedElement = null;
  }

  handleDialogClose() {
    this.finalizePanelClose();
  }

  handleDialogClick(event) {
    if (event.target !== this.mobilePanel) return;
    this.closeOptions();
  }

  handleOpenOptionsRequest(event) {
    const cardQuickAdd = event.detail?.source;
    if (!cardQuickAdd) return;
    this.openOptions(cardQuickAdd);
  }

  handleClick(event) {
    const optionButton = event.target.closest('.quick-add-mobile-panel .card-quick-add__variant-option');
    if (!optionButton || optionButton.disabled || !this.activeCardQuickAdd) return;

    event.preventDefault();
    const variantId = optionButton.getAttribute('data-variant-id');
    if (!variantId) return;

    optionButton.setAttribute('aria-busy', 'true');
    this.activeCardQuickAdd
      .addToCart(variantId)
      .finally(() => optionButton.removeAttribute('aria-busy'));
  }

  openOptions(cardQuickAdd) {
    if (!this.mobilePanel || !this.mobilePanelOptions || !cardQuickAdd) return;
    if (!window.matchMedia('(max-width: 989px)').matches) return;

    const sourceOptions = cardQuickAdd.querySelector('.card-quick-add__variant-options');
    if (!sourceOptions) return;

    if (typeof this.mobilePanel.showModal !== 'function') {
      return;
    }

    this.teardownModalTabTrap();
    this.focusReturnElement = cardQuickAdd.querySelector?.('[data-card-quick-add-trigger]') || null;
    this.lastFocusedElement = this.focusReturnElement || document.activeElement;
    this.activeCardQuickAdd = cardQuickAdd;
    cardQuickAdd.setAttribute('open', '');
    this.mobilePanelOptions.innerHTML = sourceOptions.innerHTML;
    document.body.classList.add('overflow-hidden-mobile');
    this.setModalIsolation(true);
    this.mobilePanel.showModal();
    document.addEventListener('keydown', this.onDocumentTabTrap, true);
    this.#modalTabTrapAttached = true;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const firstOption = this.mobilePanelOptions.querySelector(
          'button.card-quick-add__variant-option:not([disabled])'
        );
        if (firstOption) {
          firstOption.focus({ preventScroll: true });
        } else {
          this.mobilePanelOptions.focus();
        }
      });
    });
  }

  closeOptions() {
    if (!this.mobilePanel?.open) return;
    this.mobilePanel.close();
  }

  showStatus(status, errorMessage = '') {
    if (!status) return;

    if (this.#notificationDismissTimeout) {
      clearTimeout(this.#notificationDismissTimeout);
      this.#notificationDismissTimeout = null;
    }
    removeQuickAddNotifications(this);

    const node = mountQuickAddNotification(this, status, errorMessage);

    if (!node) return;

    if (status === 'success') focusQuickAddSuccessLink(node);

    this.#notificationDismissTimeout = setTimeout(() => {
      const activeBeforeRemove = document.activeElement;
      if (node.isConnected) node.remove();
      this.#notificationDismissTimeout = null;
      const elToFocus = this.focusReturnElement || this.lastFocusedElement;
      if (elToFocus?.isConnected && elToFocus.focus && !window.matchMedia('(hover: none)').matches) {
        elToFocus.focus({ preventScroll: true });
      } else {
        // If the opener is gone (e.g. DOM updated), just ensure the panel/notification isn't left hanging.
        this.closeOptions?.();
      }
      this.focusReturnElement = null;
      // If focus got stuck on an element that was removed, blur it.
      if (activeBeforeRemove && !document.contains(activeBeforeRemove)) activeBeforeRemove.blur?.();
    }, 5000);
  }
}

if (!customElements.get('add-to-cart-form')) {
  customElements.define('add-to-cart-form', AddToCartFormToast);
}

class StoreSelector extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.store-selector__button');
    this.list = this.querySelector('.store-selector__dropdown');
    if (!this.button) return;
    this.button.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick() {
    const willOpen = this.list.hidden;
    this.list.hidden = !willOpen;
    this.button.setAttribute('aria-expanded', String(willOpen));

    if (willOpen) {
      this.list.hidden = false;
      const rect = this.list.getBoundingClientRect();
      const spaceBelow = window.innerHeight - this.getBoundingClientRect().bottom;
      this.list.classList.toggle('store-selector__dropdown--up', rect.height > spaceBelow);
    }
  }
}

if (!customElements.get('store-selector')) customElements.define('store-selector', StoreSelector);
